class CartGift extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.onInputChange = this.onInputChange.bind(this);
    this.onToggleTooltip = this.onToggleTooltip.bind(this);

    this.toggles = this.querySelectorAll('.cart-giftbox-tooltip-toggle');
    this.tooltip = this.querySelector('.cart-giftbox--tooltip');
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.checked = this.checkbox.checked;
    this.giftId = this.dataset.giftId;

    this.checkbox.addEventListener('change', this.onInputChange);
    this.toggles.forEach(toggle => toggle.addEventListener('click', this.onToggleTooltip));
  }

  disconnectedCallback() {
    this.checkbox.removeEventListener('change', this.onInputChange);
    this.toggles.forEach(toggle => toggle.removeEventListener('click', this.onToggleTooltip));
  }

  onInputChange() {
    this.checked = !this.checked;

    if (this.checked) {
      // add giftbox
      add_v_to_cart(this.giftId, 1);
    } else {
      // remove giftbox
      remove_v_from_cart(this.giftId);
    }
  }

  onToggleTooltip() {
    this.tooltip.classList.toggle('active');
  }
}

customElements.define('cart-gift', CartGift)

function remove_v_from_cart(v_id) {
  console.log(v_id, 'remove');
  show_cart_drawer_loading();

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: v_id,
      quantity: 0,
    })
  }).then(res => {
    console.log('removed', res);
    update_cart_content();
    open_slider_cart();
    update_header_icon();
    update_pdp_shipping_part();
  })
}